module.exports = __webpack_public_path__ + "static/media/serious_jeff.ae00dee0.jpg";